<template>
  <button
    :class="[
      isSingle ? '' : 'multiple',
      isDisabled ? 'disabled' : '',
      buttonType,
      isLoading ? 'loading' : '',
    ]"
    @click="submit"
    class="customButtonWrapper"
  >
    <p v-html="customButtonTxt" v-show="!isLoading" />
    <div v-show="isLoading">
      <img
        v-svg-inline
        class="loadingIcon"
        src="../assets/imgs/loadingColor.svg"
        alt="loading"
      />
    </div>
  </button>
</template>

<script>
export default {
  props: {
    isSingle: {
      default: true,
    },
    buttonType: {
      type: String,
      default: "primary",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    customButtonTxt: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.customButtonWrapper
  &.primary
    +customButton(100%, primary)
    &.multiple
      +customButton(calc(50% - 8px), primary)
  &.accent
    +customButton(100%, accent)
    &.multiple
      +customButton(calc(50% - 8px), accent)
  &.border
    +customButton(100%, border)
    &.multiple
      +customButton(calc(50% - 8px), accent)
</style>
